module.exports = __webpack_public_path__ + "img/package_two.dce90342.jpg";